/**
 * Defines and contains the globally available roles that are nursing-home independent
 */
import { IRole } from '../../common';
import { RoleName, Roles } from './roles';

export const GLOBAL_ROLES = Object.freeze({
  globalAdmin: {
    name: RoleName.GLOBAL_ADMIN,
    rights: Roles.GLOBAL_ADMIN,
  } as IRole,
});

/**
 * Defines and contains all user-specific roles that one nursing-home should possess
 */
export const USER_ROLES = Object.freeze({
  administrator: {
    name: RoleName.ADMINISTRATOR,
    rights: Roles.ADMINISTRATOR,
  } as IRole,
  facilityManagement: {
    name: RoleName.FACILITY_MANAGEMENT,
    rights: Roles.FACILITY_MANAGEMENT,
  } as IRole,
  nursingManagement: {
    name: RoleName.NURSING_MANAGEMENT,
    rights: Roles.NURSING_MANAGEMENT,
  } as IRole,
  residentialAreaManagement: {
    name: RoleName.RESIDENTIAL_AREA_MANAGEMENT,
    rights: Roles.RESIDENTIAL_AREA_MANAGEMENT,
  } as IRole,
  qualityOfficer: {
    name: RoleName.QUALITY_OFFICER,
    rights: Roles.QUALITY_OFFICER,
  } as IRole,
  nurse: {
    name: RoleName.NURSE,
    rights: Roles.NURSE,
  } as IRole,
  nursingAssistantTrained: {
    name: RoleName.NURSING_ASSISTANT_TRAINED,
    rights: Roles.NURSING_ASSISTANT_TRAINED,
  } as IRole,
  nursingAssistantUntrained: {
    name: RoleName.NURSING_ASSISTANT_UNTRAINED,
    rights: Roles.NURSING_ASSISTANT_UNTRAINED,
  } as IRole,
  trainee: {
    name: RoleName.TRAINEE,
    rights: Roles.TRAINEE,
  } as IRole,
  supervisionManagement: {
    name: RoleName.SUPERVISION_MANAGEMENT,
    rights: Roles.SUPERVISION_MANAGEMENT,
  } as IRole,
  caregiver: {
    name: RoleName.CAREGIVER,
    rights: Roles.CAREGIVER,
  } as IRole,
  administration: {
    name: RoleName.ADMINISTRATION,
    rights: Roles.ADMINISTRATION,
  } as IRole,
  kitchenManagement: {
    name: RoleName.KITCHEN_MANAGEMENT,
    rights: Roles.KITCHEN_MANAGEMENT,
  } as IRole,
  kitchen: {
    name: RoleName.KITCHEN,
    rights: Roles.KITCHEN,
  } as IRole,
  housekeepingManagement: {
    name: RoleName.HOUSEKEEPING_MANAGEMENT,
    rights: Roles.HOUSEKEEPING_MANAGEMENT,
  } as IRole,
  housekeeping: {
    name: RoleName.HOUSEKEEPING,
    rights: Roles.HOUSEKEEPING,
  } as IRole,
  buildingServices: {
    name: RoleName.BUILDING_SERVICES,
    rights: Roles.BUILDING_SERVICES,
  } as IRole,
});
